module.exports = __webpack_public_path__ + "img/p2_r.83511768.jpg";